import { TRPropsWithoutRef } from "react-html-props";
import styled from "styled-components";
import Td from "./Td";

const Tr = styled.tr<TRPropsWithoutRef>`
  background-color: ${({ theme }) => theme.colors.white};
  transition: background-color 80ms ease-in;

  ${({ onClick, theme }) => {
    if (!onClick) return;

    return `
      :hover {
        background-color: ${theme.colors.gray50};
        cursor: pointer;

        ${Td}:first-child {
          text-decoration: underline;
        }
      }
    `;
  }}
`;

export default Tr;
